// src/services/notifications/strategies/providers/ZAPIProvider.js
import { WhatsAppProviderBase } from '../WhatsAppProviderBase';
import { whatsappTemplates } from '../../templates/whatsappTemplates';

export class ZAPIProvider extends WhatsAppProviderBase {
  constructor(config) {
    super(config);
    this.apiBaseUrl = config.apiBaseUrl;
    this.instance = config.instance;
    this.instanceToken = config.instanceToken;
    this.clientToken = config.clientToken;
  }

  async sendTemplate(template, params, to) {
    console.log("ZAPIProvider.sendTemplate chamado:", template, params, to);
    try {
      const coremsg = whatsappTemplates[template](params);
      const finalmsg = whatsappTemplates.baseTemplate(coremsg.content);

      return this.send({
        to: to,
        message: finalmsg
      });
    } catch (error) {
      console.error("Erro ao processar template:", error);
      return false;
    }
  }

  async send(payload) {
    try {
      console.log("ZAPIProvider enviando para:", payload.to);
      // Formato da URL da Z-API
      const endpoint = `${this.apiBaseUrl}/${this.instance}/token/${this.instanceToken}/send-text`;
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Client-Token': this.clientToken
        },
        body: JSON.stringify({
          phone: `55${payload.to}`,
          message: payload.message
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Erro na API do Z-API:', errorData);
        return false;
      }

      console.log("Mensagem enviada com sucesso via Z-API");
      return true;
    } catch (error) {
      console.error('Erro ao enviar mensagem via Z-API:', error);
      return false;
    }
  }
}